module.exports = __webpack_public_path__ + "static/img/6.4dbf52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/6.png
// module id = 5QNY
// module chunks = 115